import { render, staticRenderFns } from "./InventoryPackingEdit.vue?vue&type=template&id=031117b2&scoped=true"
import script from "./InventoryPackingEdit.vue?vue&type=script&lang=js"
export * from "./InventoryPackingEdit.vue?vue&type=script&lang=js"
import style0 from "./InventoryPackingEdit.vue?vue&type=style&index=0&id=031117b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031117b2",
  null
  
)

export default component.exports